import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.main', {
        url: '/main',
        component: 'companyDirectoryIntegrationManageMain',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/directory-manage-main.state.js